<template>
  <header
    class="@@link-color fixed top-0 inset-x-0 flex items-center z-40 w-full bg-white transition-all py-3.5"
  >
    <div class="container">
      <nav class="flex items-center">
        <!-- Navbar Brand Logo -->
        <router-link :to="{ name: 'dashboard' }">
          <img
            :src="settings.siteLogo"
            class="h-10 logo-dark"
            alt="Logo Dark"
          />
          <img
            :src="settings.siteLogo"
            class="h-10 logo-light"
            alt="Logo Light"
          />
        </router-link>

        <!-- Nevigation Menu -->
        <dashboard-left-menu>
          <dashboard-menu-item
            title="Aboneliklerim"
            icon="fa-user"
            to="dashboard"
          />
          <dashboard-menu-item
            title="Faturalarım"
            icon="fa-credit-card"
            to="invoices"
          />
          <dashboard-menu-item
            title="Destek Taleplerim"
            icon="fa-ticket"
            to="tickets"
          />
        </dashboard-left-menu>

        <dashboard-right-menu>
          <!-- Inner Page Dropdown -->
          <li class="nav-item">
            <router-link :to="{ name: 'profile' }">
              <div class="flex items-center">
                <div class="shrink">
                  <div class="h-8 w-8 me-2">
                    <img
                      src="/assets/images/avatars/def.png"
                      class="avatar h-full w-full rounded-full me-2"
                      alt=""
                    />
                  </div>
                </div>
                <div class="hidden lg:block grow ms-1 leading-normal">
                  <span class="block text-sm font-medium"
                    >{{ user.FullName }}
                  </span>
                  <span class="block text-gray-400 text-xs">{{
                    user.Email
                  }}</span>
                </div>
              </div>
            </router-link>
          </li>
          <li>
            <!-- log out button -->
            <button
              @click="handleSignOut"
              class="flex items-center text-gray-500 hover:text-primary ms-2"
            >
              <i class="fa-solid fa-sign-out-alt me-2"></i>
              <span>Çıkış Yap</span>
            </button>
          </li>
        </dashboard-right-menu>
        <!-- Moblie Menu Toggle Button (Offcanvas Button) -->
        <div class="lg:hidden flex items-center ms-auto px-2.5">
          <button
            type="button"
            data-fc-target="mobileMenu"
            data-fc-type="offcanvas"
          >
            <i class="fa-solid fa-bars text-2xl text-gray-500"></i>
          </button>
        </div>
      </nav>
    </div>
  </header>
</template>

<script setup>
import { useSettingsStore } from "@/stores/settingStore";
import { useAuthStore } from "@/stores/authStore";
import { signOut } from "@/services/authServices";
import DashboardMenuItem from "@/components/DashboardLayout/dashboard-components/DashboardMenuItem.vue";
import DashboardLeftMenu from "@/components/DashboardLayout/dashboard-components/DashboardLeftMenu.vue";
import DashboardRightMenu from "@/components/DashboardLayout/dashboard-components/DashboardRightMenu.vue";
import { useRouter } from "vue-router";
const settings = useSettingsStore();
const authStore = useAuthStore();
const user = authStore.user;
const router = useRouter();

const handleSignOut = async () => {
  const response = await signOut();
  if (response) {
    router.push({ name: "signin" });
  }
};
</script>
